import ArcgisMonitorMap from './arcgis-monitor-map.vue'
export default ArcgisMonitorMap
